import styled from 'styled-components';

export const SectionHomePage = styled.div`
    height: 100%;
    position: relative;
    background-position: center center;
    background-attachment: scroll;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("${props => props.image ? props.image : ''}");
`